import { useEffect, useState } from "react";
import { Download, FileLock2, Loader2 } from "lucide-react";
import { useVault } from "@/context/VaultContext";
import { saveFile } from "@/lib/native";

const fmtSize = (n) => (n < 1024 ? `${n} B` : n < 1048576 ? `${(n / 1024).toFixed(1)} KB` : `${(n / 1048576).toFixed(1)} MB`);

export function Attachment({ m }) {
  const { getFileBytes } = useVault();
  const f = m.content.file;
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!f.local) return;
    let u;
    getFileBytes(m.message_id).then((bytes) => {
      if (!bytes) return;
      u = URL.createObjectURL(new Blob([bytes], { type: f.mime }));
      setUrl(u);
    });
    return () => u && URL.revokeObjectURL(u);
  }, [f.local, f.mime, m.message_id, getFileBytes]);

  if (f.failed) return <p className="text-xs text-flare/80" data-testid={`attachment-failed-${m.message_id}`}>Encrypted file expired on the relay.</p>;
  if (!url) return <p className="text-xs text-ash/50 flex items-center gap-2" data-testid={`attachment-loading-${m.message_id}`}><Loader2 size={14} className="animate-spin" /> Decrypting {f.name}…</p>;

  return (
    <div className="space-y-2" data-testid={`attachment-${m.message_id}`}>
      {f.mime.startsWith("image/") && <img src={url} alt={f.name} className="rounded-secure max-h-72 object-contain border border-glass" data-testid={`attachment-image-${m.message_id}`} />}
      <div className="flex items-center gap-3">
        <FileLock2 size={18} strokeWidth={1.5} className="text-stellar flex-shrink-0" />
        <div className="min-w-0 flex-1"><p className="text-sm truncate">{f.name}</p><p className="text-[11px] text-ash/40">{fmtSize(f.size)}</p></div>
        <button onClick={() => saveFile(url, f.name)} data-testid={`attachment-download-${m.message_id}`} className="p-1.5 text-ash/55 hover:text-stellar"><Download size={16} strokeWidth={1.5} /></button>
      </div>
    </div>
  );
}
